export default __webpack_public_path__ + "106644a86a51194f8e3b47e293781051.png";